import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { Filter } from '../../ts/helpers/Filter';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { FieldValuesQuery } from '../../ts/resources/FieldValuesQuery';
import { IListResource } from '../../ts/resources/Resource';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { GetFieldValuesRequest } from '../../ts/ServerApi/requests/GetFieldValuesRequest';
import { FilterFieldNames, ILeafFilterClause } from '../../ts/ServerApi/types/IFilterClause';
import { IOrderClause } from '../../ts/ServerApi/types/IOrderClause';
import { FlowOutputStepRunListItemInfo } from '../models/FlowOutputStepRunInfo';
import { GetFlowOutputStepRunsRequest } from '../serverApi/requests/GetFlowOutputStepRunsRequest';
import { GetMostRecentFlowOutputStepRunRequest } from '../serverApi/requests/GetMostRecentFlowOutputStepRunRequest';

export class FlowOutputStepRunsResource implements IListResource<FlowOutputStepRunListItemInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetFlowOutputStepRunsRequest, ServerApiMapper.flowOutputStepRuns);
  private fieldValuesFetcher = new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<FlowOutputStepRunListItemInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public getForFlow(flowId: string, orderClause: IOrderClause[]): ResourceQuery<FlowOutputStepRunListItemInfo> {
    const filterClause: ILeafFilterClause[] = [Filter.stringFieldEq(FilterFieldNames.flowId, flowId)];
    return this.all().withFiltersAndOrder(filterClause, orderClause);
  }

  public getMostRecentForFlow(flowId: string, completedRunsOnly: boolean): Promise<ReadonlyArray<FlowOutputStepRunListItemInfo>> {
    return WebHttpClient.sendRequest(new GetMostRecentFlowOutputStepRunRequest({ flowId, completedRunsOnly }))
      .then((result) => ServerApiMapper.flowOutputStepRuns(result));
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'flowOutputStepRun');
  }
}

export const FlowOutputStepRuns = new FlowOutputStepRunsResource();
